import { Component, OnInit, Input, OnChanges, SimpleChanges, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error-input',
  templateUrl: './error-input.component.html',
  styleUrls: ['./error-input.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],     
  imports:[CommonModule],
})
export class ErrorInputComponent extends BaseInputDirective implements OnInit, OnChanges {
  @Input() showErrorMessage: boolean = false;
  @Input() showAsWarning: boolean = false;

  
 

 

  ngOnInit() {
    super.ngOnInit();

    this.updateTouched();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showErrorMessage'] && !changes['showErrorMessage'].firstChange) {
      this.updateTouched();
    }
  }

  updateTouched() {
    if (this.showErrorMessage) {
      this.formControl.markAsTouched();
    } else {
      this.formControl.markAsTouched();
    }
  }
}
